/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    DateTimeRestrictionData,
    DateTimeRestrictionDataFromJSON,
    DateTimeRestrictionDataFromJSONTyped,
    DateTimeRestrictionDataToJSON,
    FormDataRouteRestriction,
    FormDataRouteRestrictionFromJSON,
    FormDataRouteRestrictionFromJSONTyped,
    FormDataRouteRestrictionToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    SSRV2RuleFormDataTravelDateRestriction,
    SSRV2RuleFormDataTravelDateRestrictionFromJSON,
    SSRV2RuleFormDataTravelDateRestrictionFromJSONTyped,
    SSRV2RuleFormDataTravelDateRestrictionToJSON,
} from './';

/**
 * 
 * @export
 * @interface SSRV2RuleCreateRequest
 */
export interface SSRV2RuleCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleCreateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleCreateRequest
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleCreateRequest
     */
    contactEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleCreateRequest
     */
    contactMobile?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof SSRV2RuleCreateRequest
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof SSRV2RuleCreateRequest
     */
    providers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof SSRV2RuleCreateRequest
     */
    carriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<FormDataRouteRestriction>}
     * @memberof SSRV2RuleCreateRequest
     */
    routes?: Array<FormDataRouteRestriction> | null;
    /**
     * 
     * @type {Array<DateTimeRestrictionData>}
     * @memberof SSRV2RuleCreateRequest
     */
    bookingDateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof SSRV2RuleCreateRequest
     */
    bookingDateTimeRestrictionsTimeZone?: CodeAndLabel;
    /**
     * 
     * @type {boolean}
     * @memberof SSRV2RuleCreateRequest
     */
    includeDateTimeRestrictions?: boolean;
    /**
     * 
     * @type {Array<SSRV2RuleFormDataTravelDateRestriction>}
     * @memberof SSRV2RuleCreateRequest
     */
    travelDates?: Array<SSRV2RuleFormDataTravelDateRestriction> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SSRV2RuleCreateRequest
     */
    excludeCarriers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SSRV2RuleCreateRequest
     */
    disabled?: boolean;
}

export function SSRV2RuleCreateRequestFromJSON(json: any): SSRV2RuleCreateRequest {
    return SSRV2RuleCreateRequestFromJSONTyped(json, false);
}

export function SSRV2RuleCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSRV2RuleCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'contactEmail': !exists(json, 'contactEmail') ? undefined : json['contactEmail'],
        'contactMobile': !exists(json, 'contactMobile') ? undefined : json['contactMobile'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'carriers': !exists(json, 'carriers') ? undefined : (json['carriers'] === null ? null : (json['carriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(FormDataRouteRestrictionFromJSON)),
        'bookingDateTimeRestrictions': !exists(json, 'bookingDateTimeRestrictions') ? undefined : (json['bookingDateTimeRestrictions'] === null ? null : (json['bookingDateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionDataFromJSON)),
        'bookingDateTimeRestrictionsTimeZone': !exists(json, 'bookingDateTimeRestrictionsTimeZone') ? undefined : CodeAndLabelFromJSON(json['bookingDateTimeRestrictionsTimeZone']),
        'includeDateTimeRestrictions': !exists(json, 'includeDateTimeRestrictions') ? undefined : json['includeDateTimeRestrictions'],
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(SSRV2RuleFormDataTravelDateRestrictionFromJSON)),
        'excludeCarriers': !exists(json, 'excludeCarriers') ? undefined : json['excludeCarriers'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function SSRV2RuleCreateRequestToJSON(value?: SSRV2RuleCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'comment': value.comment,
        'contactEmail': value.contactEmail,
        'contactMobile': value.contactMobile,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'providers': value.providers === undefined ? undefined : (value.providers === null ? null : (value.providers as Array<any>).map(GuidIdAndLabelToJSON)),
        'carriers': value.carriers === undefined ? undefined : (value.carriers === null ? null : (value.carriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(FormDataRouteRestrictionToJSON)),
        'bookingDateTimeRestrictions': value.bookingDateTimeRestrictions === undefined ? undefined : (value.bookingDateTimeRestrictions === null ? null : (value.bookingDateTimeRestrictions as Array<any>).map(DateTimeRestrictionDataToJSON)),
        'bookingDateTimeRestrictionsTimeZone': CodeAndLabelToJSON(value.bookingDateTimeRestrictionsTimeZone),
        'includeDateTimeRestrictions': value.includeDateTimeRestrictions,
        'travelDates': value.travelDates === undefined ? undefined : (value.travelDates === null ? null : (value.travelDates as Array<any>).map(SSRV2RuleFormDataTravelDateRestrictionToJSON)),
        'excludeCarriers': value.excludeCarriers,
        'disabled': value.disabled,
    };
}


